import Player from '@vimeo/player';
import $ from 'jquery'; 
window.flip = false;
window.myPlayer = {pause: function() {}, element: ''};

function productJS(){
   const parent =$('#image');
   const imageGallery = $('#image .gallery-main');
   const imageNav =  $('#image .gallery-nav');
   if (imageGallery.children().length > 1){
      imageGallery.slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         asNavFor: '.gallery-nav',
         arrows: false,
         loop: true,
         infinite: false,
      });
   }
   //Put the data obtained when you create the app in developer.vimeo.com
   // var vimeoVids = new Vimeo('3fd265d9fa429306f1be8b5bb1fe5e5ce457bab9', 'tKmpAQmESP8zMVc+D95bsuuoL14IMf2kqLGf2EzlF4nXZnIq0yiJEzI4UXWNugByrtysNNNFWM+q1ON2U72dCV5DenyYK4xhgpTUiLZpP6so61ZDZYpKob3xEgovgXM8', '62123c8e3b4d61eace128bd2ed60c490');
   // console.log(viemoVids);


   // console.log(imageNav.find('button'));
   // imageNav.find('button').each(function(index) {
   //    //Hydrate blank image tag with thumbanil from video in gallery
   //    console.log('butotn loog');
   //    console.log($(this));
   //    if($(this).attr('populate') !== undefined){
   //       let el = imageGallery.find('.slide').eq(index);
   //       console.log(el);
   //       console.log(el.find('iframe'));
   //       console.log(el.find('iframe').contents().find('.vp-placeholder-thumb'));
   //    }
   // });

   resizeGallery();
   restructureNav(imageNav);
   setNavWidth();
   ///
   if($('#image > img').length != 0){
      imageZoomIn($('#image'), $('#image > img'));
      $('#image').css({"overflow" : 'hidden'})
   }
   ///
   $(window).ready(() => {
      resizeGallery();
      imageNav.slick('unslick');
      restructureNav(imageNav);
      imageGallery.find('.slick-slide').each(function() {
         imageZoomIn($(this), $(this).find('img'));
         $(this).find('img').height(parent.height());
         $(this).find('iframe').height(parent.height());
      });
      $(window).resize(() => {
         resizeGallery();
         imageNav.slick('unslick');
         restructureNav(imageNav);
         imageGallery.find('.slick-slide').each(function() {
            imageZoomIn($(this), $(this).find('img'));
            $(this).find('img').height(parent.height());
            $(this).find('iframe').height(parent.height());
         });
       });

   })

   function resizeGallery(){
      const width = parent.innerWidth() / 4;
      imageGallery.css('width', 3*width);
      imageNav.css('width', width);
   }

   function imageZoomIn(container, img) {
      $(container).on("mousemove", onZoom);
      $(container).on("mouseover", onZoom);
      $(container).on("mouseleave", offZoom);
      function onZoom(e) {
         const containerOffset = $(container).offset();
         const x = e.pageX - containerOffset.left;
         const y = e.pageY - containerOffset.top;
         const containerWidth = $(container).width();
         const containerHeight = $(container).height();
         const offsetX = (x / containerWidth) * 100;
         const offsetY = (y / containerHeight) * 100;
        $(img).css({
          transformOrigin: `${x}px ${y}px`,
          transform: "scale(2)"
        });
      }
    
      function offZoom(e) {
        $(img).css({
          //transformOrigin: "center center",
          transform: "scale(1)"
        });
      }
    }

    function restructureNav(imageNav){
      if ($(window).width() < 768) {
         imageNav.slick({
            slidesToShow: 'all',
            slidesToScroll: 1,
            asNavFor: '.gallery-main',
            centerMode: true,
            arrows: false,
            focusOnSelect: true,
            loop: true,
            infinite: false,
            vertical: false,
         })
         
      } else {
         imageNav.slick({
            slidesToShow: 'auto',
            slidesToScroll: 1,
            asNavFor: '.gallery-main',
            centerMode: true,
            arrows: false,
            focusOnSelect: true,
            loop: true,
            infinite: false,
            vertical: true,
          });
          let widthNav = imageNav.width();
          imageNav.find('img').each(function(){
            $(this).css({
               'max-width' : widthNav - 40,
               'margin' : 'auto',
            })
          });
      }
      //console.log("why?")
      imageNav.on('afterChange', function(event, slick, currentSlide){
         ///Keeps running twice for some reason
         if(window.flip){
            window.flip = !window.flip;
            return;
         }
         window.flip = !window.flip;
         let video = imageGallery.find('.slide').eq(currentSlide).find('iframe');
         if(video[0] !== undefined && window.myPlayer.element == ''){
            // First video selected
            window.myPlayer = new Player(video[0]);
            window.myPlayer.setVolume(0.3);
            window.myPlayer.play();
         } else if (video[0] == undefined && window.myPlayer.element !== ''){
            // Image selected after video
            window.myPlayer.pause();
            window.myPlayer == {pause: function() {}, element: ''};
         } else if (video[0] !== undefined && window.myPlayer.element !== '') {
            // Video selected after video
            window.myPlayer.pause();
            window.myPlayer = new Player(video[0]);
            window.myPlayer.setVolume(0.3);
            window.myPlayer.play();
         }
       });
      return;
   }
   
   function setNavWidth(){
     let arrowWidth = $('.swiper-navigation button').outerWidth();
     let activeSlideWidth = $('swiper-slide.swiper-slide-active').outerWidth();
     $('.swiper-navigation').width(activeSlideWidth + (2*arrowWidth) + 50);

     $(window).resize(function() {
      let arrowWidth = $('.swiper-navigation button').outerWidth();
      let activeSlideWidth = $('swiper-slide.swiper-slide-active').outerWidth();
      $('.swiper-navigation').width(activeSlideWidth + (2*arrowWidth) + 50);
      let parent = $('#videos');
      let navigationBar = $('#videos div.swiper-navigation');
      //let h2Height = $('#videos h2').outerHeight();
      navigationBar.css('top', (parent.height()/2) );
      if($(window).width() < 768){
         $('#videos > swiper-container').attr('slides-per-view', 1);
      }

    }).resize();
    
   }

   $('.swiper-container').on('slideChange', function() {
      setDivWidth();
    });


   $(document).ready(function($) {
      // Find the button with the attribute [wheretobuy] and add a click event handler
      $('button[wheretobuy]').on('click', function() {
         // Call the goToWhereToBuy function to navigate to the desired URL
         goToWhereToBuy();
      });

      // Define the goToWhereToBuy function
      function goToWhereToBuy() {
         window.location.href = '/where-to-buy?ONS=2'; // Replace with the correct URL and any additional query parameters if needed
      }
   });



   return (null)
}
export default productJS